import { generateCId } from "@/pages/taskpane/lib/utils/randomUUID";
import { EBusyStatus } from "./enum";
import { parseISOString } from "../../ulti";

export interface IGetResourceCalendarRequest {
  requestId: string;
  resourceId: number;
  organizer: string;
  startDate: string;
  endDate: string;
  timeZoneStandardName: string;
}

export class ResourceCalendarInfo {
  id: string;
  startDate: string;
  endDate: string;
  subject: string;
  busyStatus: EBusyStatus;
  organizerEmail: string;

  constructor(data?: Partial<ResourceCalendarInfo>) {
    const startDate = parseISOString(data?.startDate ?? "");
    const endDate = parseISOString(data?.endDate ?? "");
    this.id = generateCId();
    this.startDate = `${startDate.year}-${startDate.month.toString().padStart(2, "0")}-${startDate.day.toString().padStart(2, "0")} ${startDate.hours.toString().padStart(2, "0")}:${startDate.minutes.toString().padStart(2, "0")}:${startDate.seconds.toString().padStart(2, "0")}`;
    this.endDate = `${endDate.year}-${endDate.month.toString().padStart(2, "0")}-${endDate.day.toString().padStart(2, "0")} ${endDate.hours.toString().padStart(2, "0")}:${endDate.minutes.toString().padStart(2, "0")}:${endDate.seconds.toString().padStart(2, "0")}`;
    this.subject = data?.subject ?? "";
    this.busyStatus = (data?.busyStatus?.toLowerCase() as EBusyStatus) ?? EBusyStatus.Free;
    this.organizerEmail = data?.organizerEmail ?? "";
  }
}
